<template>
  <div v-if="userData" class="content-settings width-100">
    <div class="settings-main">
      <div class="content-header">
        Benutzereinstellungen
      </div>
      <div class="col-md-6 float-left">
        <b-form @submit="processForm">
          <b-form-group
            label="Karten-Stil:"
            label-for="mapStyle"
            class="form-label"
          >
            <b-form-select
              id="mapStyle"
              v-model="mapStyle"
              :options="mapStyles"
              :size="inputSize"
              @change="selectMapStyle"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            v-if="userData.firstName"
            label="Vorname:"
            label-for="firstName"
            class="form-label"
          >
            <b-form-input
              id="firstName"
              v-model="userData.firstName"
              type="text"
              :size="inputSize"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            v-if="userData.lastName"
            label="Nachname:"
            label-for="lastName"
            class="form-label"
          >
            <b-form-input
              id="lastName"
              v-model="userData.lastName"
              type="text"
              :size="inputSize"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            v-if="userData.email"
            label="Email:"
            abel-for="email"
            class="form-label"
          >
            <b-form-input
              id="email"
              v-model="userData.email"
              type="email"
              :size="inputSize"
              required
            ></b-form-input>
          </b-form-group>
          <b-button type="submit" class="sbh-button-light pw-change-button">
            Speichern
          </b-button>
        </b-form>
      </div>
      <div class="col-md-6 float-left">
        <b-form @submit="updatePassword">
          <b-form-group
            label="Aktuelles Passwort:"
            label-for="curpwd"
            class="form-label"
          >
            <b-form-input
              v-model="pwOld"
              type="password"
              :size="inputSize"
              required
              placeholder="aktuelles Passwort"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="Neues Passwort:"
            label-for="password1"
            class="form-label"
          >
            <b-input-group prepend>
              <b-form-input
                v-model="password1"
                :type="inputType"
                :size="inputSize"
                :state="password1Rule"
                required
                placeholder="neues Passwort"
              ></b-form-input>
              <b-input-group-prepend
                @click="switchVisibility"
                is-text
                class="show-hide-pw-prepend"
              >
                <span v-show="inputType == 'password'">
                  <i class="fas fa-eye"></i>
                </span>
                <span v-show="inputType == 'text'">
                  <i class="fas fa-eye-slash"></i>
                </span>
              </b-input-group-prepend>
            </b-input-group>
            <span class="pw1-error" v-if="typeof passwordError === 'string'">{{
              passwordError
            }}</span>
          </b-form-group>
          <b-form-group
            label="Passwort Wiederholen:"
            label-for="password2"
            class="form-label"
          >
            <b-form-input
              v-model="password2"
              type="password"
              :size="inputSize"
              :state="password2Rule"
              required
              placeholder="Passwort wiederholen"
            ></b-form-input>
          </b-form-group>
          <div class="row">
            <div v-if="passwordErrorText" class="col-md-6">
              <div class="pw-rules">
                <span class="header">Passwort-Richtlinien</span>
                <ul class="pw-rule-list">
                  <li>
                    {{ passwordErrorText["USER_PASSWORD_MINLENGTH"] }}
                  </li>
                  <li
                    v-for="key in Object.keys(passwordPolicy).filter(
                      k => k !== 'length' && passwordPolicy[k]
                    )"
                    :key="`pwdpolicy_${key}`"
                  >
                    {{
                      passwordErrorText[`USER_PASSWORD_${key.toUpperCase()}`]
                    }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-6">
              <b-button type="submit" class="sbh-button-light pw-change-button">
                Passwort ändern
              </b-button>
            </div>
          </div>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "../services/api-service";
import UserService from "../services/user-service";
import get from "lodash/get";
import debounce from "lodash/debounce";

export default {
  name: "Settings",
  computed: {
    password1Rule() {
      if (this.password1 && typeof this.passwordError !== "string") {
        return true;
      }
      return false;
    },
    password2Rule() {
      if (this.password2 && this.password2 === this.password1) {
        return true;
      }
      return false;
    },
    userPrimaryTenantId() {
      return get(
        get(this.userData, "access", []).filter(a => a.primary),
        "[0].tenantId"
      );
    }
  },
  created() {
    this.getTenantPasswordPolicy();
    this.userData = UserService.getUser();
  },
  watch: {
    password1() {
      this.validatePassword();
    }
  },
  data() {
    return {
      loading: false,
      userData: null,
      pwOld: null,
      password1: null,
      password2: null,
      mapStyle: null,
      mapStyles: [
        {
          text: "Hell",
          value: "mapbox://styles/mapbox/light-v9"
        },
        {
          text: "Dunkel",
          value: "mapbox://styles/mapbox/dark-v9"
        },
        {
          text: "Straßen (empfohlen)",
          value: "mapbox://styles/mapbox/streets-v9"
        },
        {
          text: "Satellit",
          value: "mapbox://styles/mapbox/satellite-v9"
        }
      ],
      inputSize: "lg",
      inputType: "password",
      iconClass: "fas fa-eye",
      pwLength: 6,
      passwordPolicy: null,
      passwordError: null,
      passwordErrorText: null,
      pwUpdateErrors: {
        AUTH_LOGIN_PASSWORD_MISMATCH:
          "Benutzer nicht gefunden oder falsches Passwort",
        AUTH_LOGIN_TOO_MANY_WRONG_REQUESTS:
          "Zu viele falsche Login Versuche, dieser Benutzer wird für 10 Minuten gesperrt"
      }
    };
  },
  methods: {
    processForm: function(evt) {
      evt.preventDefault();
      this.loading = true;
      this.updateUser();
    },
    selectMapStyle(style) {
      this.$bus.emit("change-map-style", style);
      localStorage.setItem("niotaMapsTheme", style);
    },
    resetForm() {
      this.password1 = null;
      this.password2 = null;
      this.pwOld = null;
    },
    switchVisibility() {
      if (this.inputType === "password") {
        this.inputType = "text";
      } else {
        this.inputType = "password";
      }
    },
    getTenantPasswordPolicy() {
      return ApiService.getTenantPasswordPolicy(this.userPrimaryTenantId)
        .then(passwordPolicy => {
          this.passwordPolicy = passwordPolicy;
          this.setErrorTexts();
        })
        .catch(error => {
          console.log(error);
          this.$notify({
            type: "error",
            message: `Fehler beim laden von Passwort Konfiguration: ${error}`,
            position: "bottom-left"
          });
        });
    },
    updateUser() {
      ApiService.updateUser(this.userData)
        .then(user => {
          this.userData = user.data;
          UserService.setUser(user.data);
          this.$store.commit("setUser", user.data);
          this.$notify({
            type: "success",
            message: "Erfolgreich gespeichert",
            position: "bottom-left"
          });
        })
        .catch(error => {
          console.log(error);
          this.$notify({
            type: "error",
            message: `Fehler beim Speichern der Daten: ${error}`,
            position: "bottom-left"
          });
        });
    },
    validatePassword: debounce(function() {
      ApiService.validateUserPassword(
        this.password1,
        this.userPrimaryTenantId
      ).then(result => {
        if (typeof result === "string") {
          const matches = result.match(/(.+?)_([0-9]+)$/);
          // special handling: length is encoded in error-message
          if (matches && matches.length) {
            let length = parseInt(matches[2]);
            this.pwLength = length;
            let message = matches[1];
            this.passwordError = this.passwordErrorText[message];
          } else {
            this.passwordError = this.passwordErrorText[result];
          }
        } else {
          this.passwordError = null;
        }
        return this.passwordError;
      });
    }, 250),
    setErrorTexts() {
      this.passwordErrorText = {
        USER_PASSWORD_MINLENGTH: `Muss eine Mindestlänge von ${
          this.passwordPolicy.length
        } Zeichen haben`,
        USER_PASSWORD_UPPERANDLOWERCASE:
          "Muss Groß- und Kleinschreibung beinhalten",
        USER_PASSWORD_SPECIALCHARACTERS: "Muss Sonderzeichen beinhalten",
        USER_PASSWORD_NUMBERS: "Muss Zahlen beinhalten"
      };
    },
    updatePassword() {
      ApiService.updatePassword(this.userData.id, this.pwOld, this.password1)
        .then(() => {
          this.resetForm();
          this.$notify({
            type: "success",
            message: "Ihr Passwort wurde erfolgreich geändert.",
            position: "bottom-left"
          });
        })
        .catch(error => {
          console.error(error);
          if (
            error.response &&
            this.pwUpdateErrors[error.response.data.message]
          ) {
            this.$notify({
              type: "error",
              message: this.pwUpdateErrors[error.response.data.message],
              position: "bottom-left"
            });
          } else {
            if (get(error, "response.data.statusCode") === 400) {
              this.$notify({
                type: "error",
                message: `Das Passwort wurde nicht geändert, speichern nicht möglich.`,
                position: "bottom-left"
              });
            } else {
              this.$notify({
                type: "error",
                message: `Fehler beim ändern des Passworts.`,
                position: "bottom-left"
              });
            }
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.pw1-error {
  font-size: 11px;
  color: red;
}
.pw-rules {
  .header {
    font-size: 14px !important;
    font-weight: 400 !important;
    padding-bottom: 5px !important;
    color: gray;
  }
  .pw-rule-list {
    color: gray;
    margin-top: 6px !important;
  }
}
</style>
